import { render, staticRenderFns } from "./BuilderActionsButton.vue?vue&type=template&id=3559aea2&scoped=true&"
import script from "./BuilderActionsButton.vue?vue&type=script&lang=js&"
export * from "./BuilderActionsButton.vue?vue&type=script&lang=js&"
import style0 from "./BuilderActionsButton.vue?vue&type=style&index=0&id=3559aea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3559aea2",
  null
  
)

export default component.exports